 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {ConnectionHandler,} from 'relay-runtime'
import SearchQueryId from '../../shared/gqlIds/SearchQueryId'
import toTeamMemberId from '../../utils/relay/toTeamMemberId'

import getGitHubIssuesConn from '../connections/getGitHubIssuesConn'

const handleGitHubCreateIssue = (
  task,
  store
) => {
  const integration = task.getLinkedRecord('integration')
  if (!integration) return
  const teamId = task.getValue('teamId')
  const meetingId = task.getValue('meetingId')
  const viewer = store.getRoot().getLinkedRecord('viewer')
  const viewerId = _optionalChain([viewer, 'optionalAccess', _ => _.getValue, 'call', _2 => _2('id')]) 
  if (!viewerId || !meetingId) return
  const teamMemberId = toTeamMemberId(teamId, viewerId)
  const teamMember = store.get(teamMemberId)
  const integrations = _optionalChain([teamMember, 'optionalAccess', _3 => _3.getLinkedRecord, 'call', _4 => _4('integrations')])
  const github = _optionalChain([integrations
, 'optionalAccess', _5 => _5.getLinkedRecord, 'call', _6 => _6('github')
, 'optionalAccess', _7 => _7.getLinkedRecord, 'call', _8 => _8('api')
, 'optionalAccess', _9 => _9.getLinkedRecord, 'call', _10 => _10('query')])
  const githubSearchQueryId = SearchQueryId.join('github', meetingId)
  const githubSearchQuery = store.get(githubSearchQueryId)
  const queryString = _optionalChain([githubSearchQuery, 'optionalAccess', _11 => _11.getValue, 'call', _12 => _12('queryString')]) 
  const query = _nullishCoalesce(_optionalChain([queryString, 'optionalAccess', _13 => _13.trim, 'call', _14 => _14()]), () => ( ''))
  const typename = integration.getType()
  if (typename !== '_xGitHubIssue') return
  const githubIssueConn = getGitHubIssuesConn(github, query)
  if (!githubIssueConn) return
  const now = new Date().toISOString()
  const newEdge = ConnectionHandler.createEdge(
    store,
    githubIssueConn,
    integration,
    'GitHubIssueEdge'
  )
  newEdge.setValue(now, 'cursor')
  ConnectionHandler.insertEdgeBefore(githubIssueConn, newEdge)
}

export default handleGitHubCreateIssue
